import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('userPopupStore', Object.keys(getters)),
	...mapState('userPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userPopupStore', Object.keys(actions)),
	...mapMutations('userPopupStore', Object.keys(mutations))
};
